module.exports = __webpack_public_path__ + "static/media/rc6.0fb2b1a0.jpg";